import { Component, EventEmitter, inject, OnInit } from '@angular/core';
import { AuthService } from '@cl/core/services';
import { AbsencesService } from '@cl/core/services/absences.service';
import { DATE_FORMAT } from '@cl/shared/constants';
import { GroupPermissionsType } from '@cl/shared/group-permissions-type.enum';
import { Absence } from '@cl/shared/models/absences/absence.model';
import { EmployeeProfileAbsence } from '@cl/shared/models/my-workplace/employee-profile-absence.model';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'cl-absence-calendar-event-info-modal',
    standalone: false,
    templateUrl: './absence-calendar-event-info-modal.component.html',
})
export class AbsenceCalendarEventInfoModalComponent implements OnInit {
    DATE_FORMAT = DATE_FORMAT;

    absence: Absence | EmployeeProfileAbsence = inject(NZ_MODAL_DATA);

    loading: boolean = false;

    absenceChanged: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private authService: AuthService,
        private absencesService: AbsencesService,
        private messageService: NzMessageService,
    ) {}

    async ngOnInit(): Promise<void> {
        if (!this.isWorkplaceAbsence(this.absence) || !this.authService.userHasPermission([GroupPermissionsType.ABSENCE_VIEW])) {
            return;
        }

        this.loading = true;
        try {
            const result = await this.absencesService.getSingle(this.absence.id);
            if (result.data) {
                this.absence = result.data;
            }
        } catch (ex) {
            if (ex.error?.errors?.length) {
                ex.error.errors.forEach((error) => this.messageService.error(error));
            } else {
                this.messageService.error('Neizdevās ielādēt pilnu prombūtnes informāciju.');
            }
        } finally {
            this.loading = false;
        }
    }

    isWorkplaceAbsence(absence: Absence | EmployeeProfileAbsence): absence is EmployeeProfileAbsence {
        return 'dateFrom' in absence;
    }

    gotoLuidaisAbsence(id: number): void {
        this.absencesService.gotoLuidaisAbsence(id);
    }
}
